import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';

export default function AnaliseDespesa() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'analise-despesa';
  return (
    <main>
      <SubTitle text="ANÁLISE – Despesas Administrativas e Comerciais" />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>
          Despesa Administrativa descolada no último trimestre face a gastos de manutenção não planejados. Fechara o FY
          em alta de 13%, impactando o EBITDA planejado.{' '}
        </li>
        <li>
          Despesa Comercial realizada apresentando deslocamento de 9,91% em relação ao Planejado, face a antecipação de
          gasto.
        </li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
